/* eslint-disable  */
// Dependency imports
import {
  Grid,
  IconButton,
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import Swal from 'sweetalert2';

// Local imports
import { ITableHeadColumn, Table } from 'components';
import { CreateConfigModal } from './createConfigModal';
import { useListConfigurations } from 'api/sdk';
import { useSnack } from 'plugins/snack';
import { useDeleteConfiguration } from 'api/sdk';
import AddconfigIcon from 'components/icons/Addconfig';
import EditName from './editName';
import { DropdownList } from './dropdownlist';
import { useAppDispatch, useAppSelector } from 'hooks';
import { RootState } from 'store';
import { updateConfigId } from 'store/inference';
import { ConfigurationCameraResponseSchema } from 'schemas/configurationCameraResponseSchema';
import EnhancedTableToolbar from 'components/Table/enhancedSearch';
import { Plus } from 'lucide-react';
import { setConfiguration } from 'store/configuration/configurationSlice';

const ActionToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black
  }
}));

export const ConfigurationListPage: React.FC = () => {
  const [createModalOpen, setCreateModalOpen] = React.useState(false);
  const [page, setPage] = useState<number>(0);
  const [searchVal, setSearchVal] = useState<any>('');
  const [expandedRowIndex, setExpandedRowIndex] = useState<number | null>(null);
  const currentConfigId = useAppSelector(
    (state: RootState) => state.configuration.configuration
  );
  const snack = useSnack();
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<any>();
  const [columns, setColumns] = React.useState<any>([]);
  const [isRowEditing, setIsRowEditing] = useState<boolean>(false);
  const { data, refetch, isLoading } = useListConfigurations();
  const { mutateAsync } = useDeleteConfiguration();

  const handleDeleteClick = (recordId: string, recordName: string) => {
    Swal.fire({
      title: 'Delete Configuration',
      text: 'Are you sure you want to delete this configuration?',
      allowOutsideClick: false,
      confirmButtonText: 'Yes, delete it!',
      showCancelButton: true,
      confirmButtonColor: '#E33030',
      cancelButtonColor: '#102633',
      cancelButtonText: 'No, cancel!',
      focusCancel: true,
      animation: true,
      customClass: {
        title: 'swal2-title',
        container: 'swal2-html-container',
        actions: 'swal2-actions'
      }
    }).then(result => {
      if (result.isConfirmed) {
        handleDelete(recordId); // Call handleDelete if the user confirms
      }
    });
  };

  const handleDelete = async (config: string) => {
    const configId = config?.toString() ?? '';
    setRows([]);
    mutateAsync({
      params: { config_id: configId }
    })
      .then(res => {
        snack({
          message: 'Configuration deleted successfully',
          severity: 'success'
        });
        if (configId === currentConfigId) {
          dispatch(updateConfigId('Select Configuration'));
          dispatch(setConfiguration('Select Configuration'));
        }
        setSearchVal('');
        setIsRowEditing(false);
        setExpandedRowIndex(null);
        refetch();
      })
      .catch(err => {
        snack({
          message: 'Failed to  delete Configuration',
          severity: 'error'
        });
      });
  };

  // const handleDelete = async (config: string) => {
  //   const configId = config?.toString() ?? '';
  //   setRows([]);
  //   mutateAsync({
  //     params: { config_id: configId }
  //   })
  //     .then(res => {
  //       snack({
  //         message: 'Configuration deleted successfully',
  //         severity: 'success'
  //       });
  //       if (configId === currentConfigId) {
  //         dispatch(updateConfigId('Select Configuration'));
  //         dispatch(setConfiguration('Select Configuration'));
  //       }
  //       setSearchVal('');
  //       setIsRowEditing(false);
  //       setExpandedRowIndex(null);
  //       refetch();
  //     })
  //     .catch(err => {
  //       snack({
  //         message: 'Failed to  delete Configuration',
  //         severity: 'error'
  //       });
  //     });
  // };

  useEffect(() => {
    const updatedColumns: ITableHeadColumn[] = [
      {
        value: 'Name',
        key: 'name',
        width: '500px',
        render: ({ value, record }) => {
          if (typeof value === 'string') {
            console.log('vvrrr', value, record);
            return (
              <EditName
                value={value}
                type="config"
                configId={record}
                refetch={refetch}
                isRowEditing={isRowEditing}
                setIsRowEditing={setIsRowEditing}
              />
            );
          }
          return null; // Or handle other types appropriately
        }
      },
      {
        value: 'Creator',
        key: 'creator',
        width: '350px',
        render: ({ value }) => {
          return (
            <p className="text-[#102633] text-[0.9vw]">{value as string}</p>
          );
        }
      },
      {
        value: 'Flow Type',
        key: 'configuration_type',
        width: '350px',
        render: ({ value }) => {
          return (
            <p className="text-[#102633] text-[0.9vw]">{value as string}</p>
          );
        }
      },
      {
        value: 'Date Created',
        key: 'date-modified',
        width: '400px',
        render: ({ value }) => {
          return (
            <p className="text-[#102633] text-[0.9vw]">
              {moment
                .utc(value || Date.now())
                .local()
                .format('MMM DD, YYYY, h:mm a')}
            </p>
          );
        }
      },
      {
        value: 'No: of Videos Uploaded',
        key: 'videos-uploaded',
        width: '400px',
        render: ({ value }) => {
          return (
            <p className="text-[#102633] text-[0.9vw]">{value as string}</p>
          );
        }
      },
      {
        value: 'Actions',
        key: 'actions',
        width: '250px',
        render: ({ value, record }) => {
          return (
            <IconButton
              onClick={() =>
                record &&
                typeof record?.id === 'string' &&
                typeof record?.name === 'string' &&
                handleDeleteClick(record.id, record?.name)
              }
            >
              <ActionToolTip title="Delete">
                <DeleteIcon
                  fontSize="small"
                  color="primary"
                  style={{ width: '1.5vw' }}
                />
              </ActionToolTip>
            </IconButton>
          );
        }
      }
    ];
    setColumns(updatedColumns);

    const updatedRows = data?.data
      .filter((item: any) => {
        if (
          typeof item.name === 'string' &&
          item.name.toLowerCase().includes(searchVal.toLowerCase())
        ) {
          return item;
        }
      })
      .map(item => ({
        id: item.id,
        name: item.name,
        creator: item?.created_by_name ? item?.created_by_name : 'John Doe',
        configuration_type: item?.config_type
          ? item?.config_type === 'spatio_temporal'
            ? 'Spatio Temporal'
            : 'Pick and Place'
          : 'N/A',
        'date-modified': item?.created_at,
        'videos-uploaded': item?.cameras.length,
        cameras: item.cameras,
        Analytics: item.analytics,
        site_id: item.site_id
      }));
    setRows(updatedRows);
  }, [data, isRowEditing, searchVal]);

  let DataCount = data && data?.data?.length;

  return (
    <div className="w-full p-4 flex flex-col gap-2">
      <div className="flex w-full items-center justify-between py-1.5">
        <h2 className="text-[1.1vw] font-[Proxima-Nova-Bold]">Configuration</h2>
        <div className="flex items-center justify-end gap-3">
          <EnhancedTableToolbar
            setRow={setRows}
            setPage={setPage}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            rows={rows}
            setExpandedRowIndex={setExpandedRowIndex}
            setIsRowEditing={setIsRowEditing}
          />
          <button
            className="bg-[#102433] px-[3vw] py-[5px] text-white text-[1vw] rounded-sm flex items-center justify-start gap-2"
            onClick={() => setCreateModalOpen(true)}
          >
            <Plus className="w-[1.2vw] h-auto" />
            Configuration
          </button>
        </div>
      </div>
      <Table
        columns={columns}
        rows={rows}
        setIsRowEditing={setIsRowEditing}
        expandedRowIndex={expandedRowIndex}
        setExpandedRowIndex={setExpandedRowIndex}
        searchVal={searchVal}
        setSearchVal={setSearchVal}
        expandedRowRender={record => {
          return (
            <DropdownList
              record={record.cameras as ConfigurationCameraResponseSchema[]}
              siteId={record.site_id as string}
              configId={record.id as string}
            />
          );
        }}
        striped={true}
        loading={isLoading}
        stickyHeader
        showSearch={false}
        page={page}
        setPage={setPage}
        containerStyle={{ height: '65vh' }}
      />
      {DataCount !== 0 && (
        <div className="h-[60vh] flex items-center justify-center">
          <div className="flex items-center flex-col">
            <IconButton
              style={{ backgroundColor: 'transparent' }}
              onClick={() => setCreateModalOpen(true)}
            >
              <AddconfigIcon />
            </IconButton>
            <p className="text-[1.2vw] text">ADD CONFIGURATION</p>
          </div>
        </div>
      )}
      <CreateConfigModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSucess={() => {
          setCreateModalOpen(false);
          refetch();
        }}
      />
    </div>
  );
};
